import { of } from 'rxjs';
import * as _ from 'lodash';
var DefaultSimulateRemoteViewProtocol = /** @class */ (function () {
    function DefaultSimulateRemoteViewProtocol(views, mainViewIndex) {
        this.views = views;
        this.mainViewIndex = mainViewIndex;
    }
    DefaultSimulateRemoteViewProtocol.prototype.getReleasedMainView = function () {
        var _this = this;
        var mainView = _.find(this.views, function (v) { return v.viewIndex === _this.mainViewIndex; });
        return of(mainView);
    };
    DefaultSimulateRemoteViewProtocol.prototype.getReleasedView = function (viewIndex) {
        var view = _.find(this.views, function (v) { return v.viewIndex === viewIndex; });
        return of(view);
    };
    DefaultSimulateRemoteViewProtocol.prototype.getViewConfigByConfigureViewId = function (configureViewId) {
        configureViewId = this.mainViewIndex;
        var view = _.find(this.views, function (v) { return v.viewIndex === configureViewId; });
        return of(view);
    };
    DefaultSimulateRemoteViewProtocol.prototype.getViewConfigByConfigureViewCode = function (configureViewCode) {
        var _this = this;
        var view = _.find(this.views, function (v) { return v.viewIndex === _this.mainViewIndex; });
        return of(view);
    };
    return DefaultSimulateRemoteViewProtocol;
}());
export { DefaultSimulateRemoteViewProtocol };
